import React from "react";

export interface IntroStepItem {
  icon?: string;
  text: string;
}
interface Props {
  introStepsList: Array<IntroStepItem>;
  parentClass?: string;
}

function RenderIntroSteps(props: Props) {
  const { introStepsList, parentClass = "" } = props;
  return (
    <div
      className={`border border-[#EAEAEA] rounded-[10px] p-20 w-2/4 max-w-xl sm:w-[90%] ${
        parentClass || ""
      }`}
    >
      {introStepsList.map((stepObj: IntroStepItem, index: number) => (
        <div className="flex items-start mb-48 last:mb-10" key={index}>
          <div
            className={`bg-[#2A77F2]/10 w-52 h-52 min-w-[52px] flex items-center
            justify-center rounded-[10px] mr-20
          `}
          >
            <div className={`rista-sprite ${stepObj?.icon || ""}`}></div>
          </div>
          <div className="">
            <p className="text-12 text-[#95AACB] font-semibold sm:text-[12px]">{`Step ${
              index + 1
            }`}</p>
            <p className="text-15 text-[#494E55] sm:text-[13px]">
              {stepObj?.text}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default RenderIntroSteps;
